
define('text!vb/components/messagebar/view.html',[],function () { return '';});

